// src/components/dashboard/BirthdayCard.jsx
import React from "react";
import {
    CardHeader,
    CardContent,
    Avatar,
    Typography,
    Stack,
    Box,
    Divider,
} from "@mui/material";
import { SoftCard } from "./dashboardStyles";

const BirthdayCard = ({ aniversariantes, bege, cinza }) => {
    return (
        <SoftCard sx={{ height: { xs: 360, md: 450 } }}>
            <CardHeader
                title="Aniversariantes da Semana"
                subheader="Clientes com aniversário entre segunda e domingo"
            />
            <CardContent sx={{ maxHeight: 320, overflowY: "auto" }}>
                {aniversariantes.length > 0 ? (
                    aniversariantes.map((cli, idx) => (
                        <React.Fragment key={idx}>
                            <Stack direction="row" alignItems="center" spacing={2} py={1}>
                                <Avatar sx={{ bgcolor: bege, color: cinza, fontWeight: 700 }}>
                                    🎂
                                </Avatar>
                                <Box>
                                    <Typography fontWeight={700} color={cinza}>
                                        {cli.nome}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        {cli.telefone} — {cli.data}
                                    </Typography>
                                </Box>
                            </Stack>
                            {idx < aniversariantes.length - 1 && <Divider />}
                        </React.Fragment>
                    ))
                ) : (
                    <Typography variant="body2" color="text.secondary">
                        Nenhum aniversariante nesta semana.
                    </Typography>
                )}
            </CardContent>
        </SoftCard>
    );
};

export default BirthdayCard;
